<ag-grid-angular style="width: 100%; height: 100%;" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"
    [rowData]="bays" [class]="themeClass" [detailCellRenderer]="detailCellRenderer" [detailRowHeight]="450"
    [masterDetail]="true" (gridReady)=" onGridReady($event)">
</ag-grid-angular>